// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ace-editor {
  width: 100%;
  min-height: 136px;
  font-family:
    IBM Plex Mono,
    Consolas,
    Monaco,
    Andale Mono,
    Ubuntu Mono,
    monospace;
  font-size: 14px;
}

.ace-tm .ace_active-line {
  background-color: #F3F4F6;
}

.ace-tm .ace_cursor {
  display: none !important;
}

.ace-tm.ace_focus .ace_active-line {
  background-color: #DEECFF;
}

.ace-tm.ace_focus .ace_cursor {
  display: block !important;
  border-left: 1px solid;
  color: #66758F;
}

.ace-tm .ace_autocomplete {
  width: inherit;
  max-width: 500 !important;
}

.ace-tm .ace_content {
  color: #19212E;
}

.ace-tm .ace_fold-widget.ace_invalid {
  background-color: #FFEBE6;
  border-color: #DC3309;
}

.ace-tm .ace_variable {
  color: #19212E;
}

.ace-tm .ace_string {
  color: #008559;
}

.ace-tm .ace_constant.ace_numeric {
  color: #FFAB00;
}

.ace-tm .ace_scroller {
  left: 42px !important;
}

.ace-tm .ace_gutter {
  background-color: #F3F4F6;
  color: #8C95A6;
  width: 42px !important;
}

.ace-tm .ace_gutter > * {
  width: 42px !important;
}

.ace-tm .ace_gutter-active-line.ace_gutter-cell {
  background-color: #E7EAEE;
  padding-right: 0.75rem;
}

.ace-tm .ace_gutter-cell {
  padding-right: 0.75rem;
}

.ace-tm .ace_gutter-cell.ace_error {
  background-image: none;
  background-color: #FFEBE6;
}

.ace-tm .ace_gutter-cell.ace_error:before {
  content: '•';
  color: #DC3309;
  font-size: 30px;
  position: absolute;
  left: 1px;
  top: -11px;
}

.ace-tm .ace_scroller.ace_scroll-left {
  box-shadow: none;
}

.ace-tm .ace_tooltip.ace_error {
  background-color: #000000;
  border: none;
  border-radius: 12px;
  color: #FFFFFF;
  padding: 0.75rem 1rem;
  font-family: Inter, Arial, Verdana, Helvetica, sans-serif;
}

.ace-tm .ace_placeholder {
  color: #8C95A6;
  font-family:
    IBM Plex Mono,
    Consolas,
    Monaco,
    Andale Mono,
    Ubuntu Mono,
    monospace;
  font-size: 14px;
  top: 10px;
  padding: 0 !important;
  margin: 0;
  left: 0.25rem;
}

.ace-editor.json-editor--disabled {
  background-color: #F3F4F6;
}

.ace-editor.json-editor--disabled .ace_cursor,
.ace-editor.json-editor--disabled .ace_active-line {
  display: none !important;
}

.ace-editor.json-editor--disabled .ace_content,
.ace-editor.json-editor--disabled .ace_numeric,
.ace-editor.json-editor--disabled .ace_string,
.ace-editor.json-editor--disabled .ace_variable {
  color: #66758F;
}

.ace-editor.json-editor--disabled .ace_gutter,
.ace-editor.json-editor--disabled .ace_gutter-active-line.ace_gutter-cell {
  background-color: #E7EAEE;
}

.ace-editor.json-editor--readonly .ace_cursor,
.ace-editor.json-editor--readonly .ace_active-line {
  display: none !important;
}

.ace-editor.json-editor--readonlywithoutstyles .ace_cursor,
.ace-editor.json-editor--readonlywithoutstyles .ace_active-line {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/form/JsonEditor/jsonEditor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB;;;;;;aAMW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAA6B;AAC/B;;AAEA;EACE,yBAAuC;EACvC,qBAAmC;AACrC;;AAEA;EACE,cAA6B;AAC/B;;AAEA;EACE,cAA8B;AAChC;;AAEA;EACE,cAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAwC;EACxC,cAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAwC;EACxC,sBAA6B;AAC/B;;AAEA;EACE,sBAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yBAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,cAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,cAA0B;EAC1B,qBAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,cAA6B;EAC7B;;;;;;aAMW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,SAAS;EACT,aAAoB;AACtB;;AAEA;EACE,yBAAwC;AAC1C;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;EAIE,cAA6B;AAC/B;;AAEA;;EAEE,yBAAwC;AAC1C;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":[".ace-editor {\n  width: 100%;\n  min-height: 136px;\n  font-family:\n    IBM Plex Mono,\n    Consolas,\n    Monaco,\n    Andale Mono,\n    Ubuntu Mono,\n    monospace;\n  font-size: 14px;\n}\n\n.ace-tm .ace_active-line {\n  background-color: theme(colors.grey.100);\n}\n\n.ace-tm .ace_cursor {\n  display: none !important;\n}\n\n.ace-tm.ace_focus .ace_active-line {\n  background-color: theme(colors.blue.100);\n}\n\n.ace-tm.ace_focus .ace_cursor {\n  display: block !important;\n  border-left: 1px solid;\n  color: theme(colors.grey.600);\n}\n\n.ace-tm .ace_autocomplete {\n  width: inherit;\n  max-width: 500 !important;\n}\n\n.ace-tm .ace_content {\n  color: theme(colors.grey.700);\n}\n\n.ace-tm .ace_fold-widget.ace_invalid {\n  background-color: theme(colors.red.100);\n  border-color: theme(colors.red.600);\n}\n\n.ace-tm .ace_variable {\n  color: theme(colors.grey.700);\n}\n\n.ace-tm .ace_string {\n  color: theme(colors.green.600);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: theme(colors.yellow.500);\n}\n\n.ace-tm .ace_scroller {\n  left: 42px !important;\n}\n\n.ace-tm .ace_gutter {\n  background-color: theme(colors.grey.100);\n  color: theme(colors.grey.500);\n  width: 42px !important;\n}\n\n.ace-tm .ace_gutter > * {\n  width: 42px !important;\n}\n\n.ace-tm .ace_gutter-active-line.ace_gutter-cell {\n  background-color: theme(colors.grey.200);\n  padding-right: theme(space.3);\n}\n\n.ace-tm .ace_gutter-cell {\n  padding-right: theme(space.3);\n}\n\n.ace-tm .ace_gutter-cell.ace_error {\n  background-image: none;\n  background-color: theme(colors.red.100);\n}\n\n.ace-tm .ace_gutter-cell.ace_error:before {\n  content: '•';\n  color: theme(colors.red.600);\n  font-size: 30px;\n  position: absolute;\n  left: 1px;\n  top: -11px;\n}\n\n.ace-tm .ace_scroller.ace_scroll-left {\n  box-shadow: none;\n}\n\n.ace-tm .ace_tooltip.ace_error {\n  background-color: theme(colors.black);\n  border: none;\n  border-radius: 12px;\n  color: theme(colors.white);\n  padding: theme(space.3) theme(space.4);\n  font-family: Inter, Arial, Verdana, Helvetica, sans-serif;\n}\n\n.ace-tm .ace_placeholder {\n  color: theme(colors.grey.500);\n  font-family:\n    IBM Plex Mono,\n    Consolas,\n    Monaco,\n    Andale Mono,\n    Ubuntu Mono,\n    monospace;\n  font-size: 14px;\n  top: 10px;\n  padding: 0 !important;\n  margin: 0;\n  left: theme(space.1);\n}\n\n.ace-editor.json-editor--disabled {\n  background-color: theme(colors.grey.100);\n}\n\n.ace-editor.json-editor--disabled .ace_cursor,\n.ace-editor.json-editor--disabled .ace_active-line {\n  display: none !important;\n}\n\n.ace-editor.json-editor--disabled .ace_content,\n.ace-editor.json-editor--disabled .ace_numeric,\n.ace-editor.json-editor--disabled .ace_string,\n.ace-editor.json-editor--disabled .ace_variable {\n  color: theme(colors.grey.600);\n}\n\n.ace-editor.json-editor--disabled .ace_gutter,\n.ace-editor.json-editor--disabled .ace_gutter-active-line.ace_gutter-cell {\n  background-color: theme(colors.grey.200);\n}\n\n.ace-editor.json-editor--readonly .ace_cursor,\n.ace-editor.json-editor--readonly .ace_active-line {\n  display: none !important;\n}\n\n.ace-editor.json-editor--readonlywithoutstyles .ace_cursor,\n.ace-editor.json-editor--readonlywithoutstyles .ace_active-line {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
